import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let types = useDataValue({
    context: 'charge_types',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'charge',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      let type = types.find(item => item.id === value)

      // the price could also be 0
      if (typeof type?.price === 'number') {
        next.type_id = type.id
        next.name = type.name
        next.amount = type.price
        next.affecting_production_report = type.affecting_production_report
      } else {
        // custom value selected
        next.type_id = value
        next.name = value
        next.affecting_production_report = true
      }
    })
  }
}
